import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl) {
    // eslint-disable-next-line no-console
    console.warn('REACT_APP_SUPABASE_URL is not set; Supabase features will be disabled.');
}

if (!supabaseAnonKey) {
    // eslint-disable-next-line no-console
    console.warn('REACT_APP_SUPABASE_ANON_KEY is not set; Supabase features will be disabled.');
}

export const supabase = supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey)
    : null;
